/*
 * AdminSettings Messages
 *
 * This contains all the text for the AdminSettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  settings: {
    id: 'app.common.settings',
    defaultMessage: 'Settings',
  },
  schoolDetails: {
    id: 'app.components.AdminSettings.schoolDetails',
    defaultMessage: 'School Details',
  },
  account: {
    id: 'app.components.AdminSettings.account',
    defaultMessage: 'Account',
  },
  onlyBySocs: {
    id: 'app.components.AdminSettings.onlyBySocs',
    defaultMessage: 'Can be edited by Social Schools only',
  },
  brin: {
    id: 'app.components.AdminSettings.brin',
    defaultMessage: 'Account ID',
  },
  name: {
    id: 'app.common.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'app.common.email',
    defaultMessage: 'Email',
  },
  address: {
    id: 'app.components.EditProfile.address',
    defaultMessage: 'Address',
  },
  phoneNumber: {
    id: 'app.components.EditProfile.phoneNumber',
    defaultMessage: 'Phone',
  },
  websiteUrl: {
    id: 'app.components.AdminSettings.websiteUrl',
    defaultMessage: 'Web Site',
  },
});
